import React, { useState, useEffect } from "react";
import "./heavy-header.css";

import amc_logo from "../../../../../assets/imgs/amc-domestico/logo_AMC.png";
import pink_lines from "../../../../../assets/imgs/amc-domestico/Estelas_AMC.svg";

import { useLocation, useNavigate } from "react-router-dom";
import { IoMdExit } from "react-icons/io";
import Swal from "sweetalert2";
import axios from "axios";

function HeavyHeader() {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const userName = localStorage.getItem("heavy-load-user");
  const routes = ["/amc-domestico/heavy-load"];

  const isLogin = routes.some((ruta) =>
    new RegExp(`^${ruta}/?$`).test(location.pathname)
  );

  const handleOpenDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const logOut = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/user/logout`;
      const body = {
        user_id: localStorage.getItem("heavy-load-email"),
        profile: localStorage.getItem("heavy-load-profile"),
      };
      await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
        },
      });
      localStorage.clear();
      sessionStorage.clear();
      navigate("/amc-domestico/heavy-load/");
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Error al cerrar sesión", "error");
    }
  };

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();

      return `${dayName}, ${day} de ${monthName} ${year}`;
    }

    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");

      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }

    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="amc-domestic-header">
        <div className="amc-domestic-header-img">
          <div className="logo">
            <img src={amc_logo} alt="Logo" />
          </div>
          <div className="lines_pink">
            <img src={pink_lines} alt="lines" />
          </div>
        </div>
        <div className="amc-domestic-header-hours">
          <div className="hours" style={isLogin ? { width: "100%" } : {}}>
            <span>{currentDate}</span>
            <span>{currentTime}</span>
          </div>
          {isLogin ? (
            ""
          ) : (
            <div className="user">
              <div className="username">
                <span>Usuario: {userName}</span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={handleOpenDropdown}
                >
                  ▼
                </span>
              </div>
              {openDropdown && (
                <div className="dropdownMenuHeader">
                  <ul>
                    <li>
                      <button
                        type="button"
                        className="exit-btn"
                        onClick={logOut}
                      >
                        Cerrar sesión <IoMdExit />
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default HeavyHeader;
